
var experience = localStorage.getItem('experience') ? localStorage.getItem('experience') : 'individual-challenge';

export function getExperience() {
    return experience
}

export function setExperience(e) {
    localStorage.setItem('experience', e)
    experience = e 
}


  